// extracted by mini-css-extract-plugin
export default {"basket":"Cart_basket__4ei-O","items":"Cart_items__12lfo","itemsPrice":"Cart_itemsPrice__6X1z-"};